var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(28.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8409255,6.98645144 C25.7702808,6.92504499 29.0084212,10.0547545 29.0808286,13.9839225 L29.0808286,22.6894377 L14.4908259,22.6894377 L14.4908259,14.0830993 C14.6442956,10.1305754 17.8854506,7.00118428 21.8409255,6.98645144 L21.8409255,6.98645144 Z M35.4832392,23.2955179 L35.4832392,13.5761959 C35.3384973,6.23343107 29.2833655,0.390154955 21.9401022,0.506903417 C14.599238,0.396230828 8.5476938,6.23604487 8.39696529,13.5761959 L8.39696529,23.2955179 C3.85270282,24.6313245 0.719276731,28.7853522 0.683217649,33.5217433 L0.683217649,53.1697606 C0.735281053,56.0778904 1.94301096,58.8456357 4.03962299,60.8616088 C6.13623501,62.8775819 8.94919668,63.9758862 11.8571321,63.9139091 L32.2324455,63.9139091 C38.267722,64.0183353 43.2476889,59.2158722 43.3622814,53.1807802 L43.3622814,33.5217433 C43.1569132,28.7919271 40.0043294,24.7001819 35.4832392,23.2955179 Z",
    id: "Shape",
    stroke: "#000001",
    fillOpacity: 0.5,
    fill: "#FF6F61",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9178047,23.4938714 L13.9178047,13.9288243 C14.1709386,9.95960805 17.312562,6.78506346 21.2789239,6.49056766 L21.2789239,1.10196395 C17.970526,1.12526223 14.806896,2.46190481 12.4840386,4.81782778 C10.1611812,7.17375076 8.86938555,10.3559562 8.89284907,13.664353 L8.69449556,23.9787355 C4.49601291,25.3341512 1.56478281,28.1000807 1.56478281,32.6511918 L1.56478281,51.384579 C1.56183093,54.1296867 2.6532764,56.7627297 4.59746179,58.7007103 C6.54164718,60.6386908 9.17816564,61.721714 11.9232499,61.7100755 L21.4001399,61.7100755 L21.4001399,23.4938714 L13.9178047,23.4938714 Z",
    id: "Path",
    fill: "#FFF2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9569545,63.3519075 L12.011407,63.3519075 C9.17735794,63.4139311 6.43495291,62.3465054 4.3885711,60.3848728 C2.34218928,58.4232401 1.15979364,55.7284074 1.10196395,52.8942696 L1.10196395,33.7090772 C1.21653202,27.8139546 6.08303759,23.1249508 11.9783481,23.2294001 L31.9569545,23.2294001 C37.8504012,23.1249901 42.7137509,27.8157057 42.8223191,33.7090772 L42.8223191,52.8942696 C42.637108,58.7504637 37.8159482,63.3907077 31.9569545,63.3519075 Z",
    id: "Path",
    fill: "#FFF2E3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9569545,23.1412429 L12.2758784,23.1412429 C9.30600299,23.0278132 6.4213458,24.147117 4.30523817,26.2340081 C2.18913054,28.3208993 1.02983245,31.1897171 1.10196395,34.1608824 L1.10196395,53.2028195 C1.09329536,54.6646035 1.42133986,56.1087535 2.06067259,57.4233414 C11.8681517,46.1282109 21.8299058,34.2710788 31.9569545,23.1412429 Z",
    id: "Path",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7887436,49.489201 C26.618708,46.9974382 24.5478562,45.0630834 22.0502986,45.0630834 C19.5527411,45.0630834 17.4818892,46.9974382 17.3118536,49.489201 C17.3736334,51.2203059 18.4173898,52.7645521 20.0006457,53.4672908 L20.0006457,58.0294216 L24.2432069,58.0294216 L24.2432069,53.4672908 C25.7570077,52.70838 26.7339176,51.181694 26.7887436,49.489201 Z",
    id: "Path",
    stroke: "#231F20",
    fill: "#FF6F61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9a149eccf3587c724b6be3696dc382d4.svg";
export { ForwardRef as ReactComponent };